// Get screen size from getComputedStyle (so we don't have to define each breakpoint twice) -- Values are set in CSS --
export var getScreenSize = function( sizeString ) {

	var size = window.getComputedStyle( document.body, ':before' ).getPropertyValue( 'content' );

	if ( size && size.indexOf( sizeString ) !== -1 ) {
		return true;
	}
};
